import {
  TransferFondoSaluteWizard,
  TransferFondoSaluteWizardStepEnum,
} from 'app/src/features/Shopping/Transfer/TransferFondoSalute/components/TransferFondoSaluteWizard'
import { moneytransferApi, shoppingApi, TransferStatusValueEnum } from 'app/src/services/welfareportal'
import { PageWidget } from 'app/src/shared/components'
import { ProgressSpinner } from 'primereact/progressspinner'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

export function TransferFondoSalute() {
  const params = useParams()

  const credit = shoppingApi.useCreditGet(
    {},
    {
      meta: {
        skip404Errors: true,
      },
    },
  )
  const transferGet = moneytransferApi.useTransferRequestGet({
    pathParams: {
      transferId: params['id']!,
    },
  })

  const { t } = useTranslation('shopping', { keyPrefix: 'Transfer' })

  /** spinner when fetching data */
  if (transferGet.isLoading || credit.isLoading || transferGet.isFetching || credit.isFetching) {
    return (
      <PageWidget>
        <h1 className='welfareportal-titlecenter'>{t('loadingInProgressTitle')}</h1>
        <div className='mt-20 flex'>
          <div className='mx-auto'>
            <ProgressSpinner data-testid='loading-element' className='flex' />
            {t('loadingInProgressDescription') && (
              <div className='mt-4' dangerouslySetInnerHTML={{ __html: t('loadingInProgressDescription') }} />
            )}
          </div>
        </div>
      </PageWidget>
    )
  }

  if (credit.isError || transferGet.isError) {
    return (
      <TransferFondoSaluteWizard
        transferDetails={transferGet?.data}
        creditDetails={credit?.data}
        initialStep={TransferFondoSaluteWizardStepEnum.ERROR_GENERIC}
      />
    )
  } else if (!transferGet?.isError && transferGet?.data && !credit.isError && credit.data) {
    switch (transferGet?.data?.status?.value) {
      case TransferStatusValueEnum.DRAFT.toString():
        if (transferGet?.data?.familyMembers && transferGet?.data?.familyMembers.length > 0)
          return (
            <TransferFondoSaluteWizard
              transferDetails={transferGet?.data}
              creditDetails={credit?.data}
              initialStep={TransferFondoSaluteWizardStepEnum.FIRST_STEP_WITH_FAMILY_MEMBERS}
            />
          )
        else
          return (
            <TransferFondoSaluteWizard
              transferDetails={transferGet?.data}
              creditDetails={credit?.data}
              initialStep={TransferFondoSaluteWizardStepEnum.FIRST_STEP_WITHOUT_FAMILY_MEMBERS}
            />
          )
        break
      case TransferStatusValueEnum.SUBMITTED.toString():
      case TransferStatusValueEnum.CONFIRMED.toString():
      case TransferStatusValueEnum.CANCELED.toString():
      case TransferStatusValueEnum.REJECTED.toString():
        return (
          <TransferFondoSaluteWizard
            transferDetails={transferGet?.data}
            creditDetails={credit?.data}
            initialStep={TransferFondoSaluteWizardStepEnum.DETAIL_STEP}
          />
        )
        break
      case TransferStatusValueEnum.FAILED.toString():
        return (
          <TransferFondoSaluteWizard
            transferDetails={transferGet?.data}
            creditDetails={credit?.data}
            initialStep={TransferFondoSaluteWizardStepEnum.ERROR_GENERIC}
          />
        )
        break
      default:
        break
    }
  } else return
}
